module.exports = __webpack_public_path__ + "img/confectionery.60ec1499.svg";